import { useLocale, useSetLocale } from "react-admin";

import { Button } from "@mui/material";

const LocaleSwitcher = () => {
  const locale = useLocale();
  const setLocale = useSetLocale();

  const onClick = (newLocale) => {
    localStorage.setItem("locale", newLocale);
    setLocale(newLocale);
  };

  return (
    <span style={{ marginTop: 2 }}>
      {locale !== "cs" ? (
        <Button onClick={() => onClick("cs")}>CZ</Button>
      ) : null}
      {locale !== "en" ? (
        <Button onClick={() => onClick("en")}>EN</Button>
      ) : null}
      {locale !== "sk" ? (
        <Button onClick={() => onClick("sk")}>SK</Button>
      ) : null}
      {locale !== "de" ? (
        <Button onClick={() => onClick("de")}>DE</Button>
      ) : null}
    </span>
  );
};

export default LocaleSwitcher;
